module.exports = __webpack_public_path__ + "img/58.ca2edd22.jpg";